module.exports = "https://static.web-explore.prod.moonpig.net/_next/static/images/GoogleLogo-51a7dc6fea30cadc70a2f35ba28988e7.svg";